// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv{\n    display: block;\n}\n.chart-wrapper{\n    display: block;\n}\n.chart{\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n}\n.all-charts{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 20px;\n}\n#select-gene{\n    width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
